import React, { useState, useContext } from "react"
import { Redirect } from "react-router-dom"
import { Button } from "reactstrap"

import { AuthContext } from '@meddbriefer/mdb-auth'
import { useScenario } from "../../contexts/ScenarioContext"

import MDBModal from "./MDBModal"


export default function ScenarioDoneModal({observer, next}) {
    const { saveUserData, getUserData } = useContext(AuthContext)
    const {scenario, showScenarioComplete, setShowScenarioComplete, saveScenarioToLog} = useScenario()
    const [obsLogID, setObsLogID] = useState(null)
    const [doRedirect, setDoRedirect] = useState(false)
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [startTime, setStartTime] = useState(Date.now())
    const handleCancel = () => setShowScenarioComplete(false)

    const handleSubmit = async (event) => {
        event.preventDefault()
        console.log("submit clicked")
        const observerLogID = await saveScenarioToLog(observer)
        setObsLogID(observerLogID)
        setShowScenarioComplete(false)
        const userData = await getUserData()
        const timeOnTask = userData.timeOnTask ? [...userData.timeOnTask] : []
        timeOnTask.push({scenario: scenario.name, task: "observation", startTime: startTime, endTime: Date.now()})
        console.table(timeOnTask)
        await saveUserData("timeOnTask", timeOnTask)
        setDoRedirect(true)
    }

    if (doRedirect) {
        const URL = `${next}/${obsLogID}`
        // console.log("redirect url", URL)
        return (
            <Redirect to={URL} />
        )
    }

    return (
        <MDBModal
            title="Scenario Complete"
            show={showScenarioComplete}
        >
            <div>
                <p>WARNING: you will not be able to work on this scenario anymore if you click submit</p>
                <p>Click 'cancel' if you wish to continue working on this scenario</p>
            </div>
            <div>
                <Button type="button" color="success" size="lg" onClick={handleCancel}>Cancel</Button>
                <Button type="button" color="danger" size="lg" onClick={handleSubmit}>Submit</Button>
            </div>
        </MDBModal>
    )
}